import { render } from "./px-callout.vue?vue&type=template&id=b5ddb672&scoped=true&ts=true"
import script from "./px-callout.vue?vue&type=script&lang=ts"
export * from "./px-callout.vue?vue&type=script&lang=ts"

import "./px-callout.vue?vue&type=style&index=0&id=b5ddb672&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ddb672"]])

export default __exports__